import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

import Main from './pages/Main';
import Invite from './pages/invite';
import RsvpList from './pages/rsvp_list';

import './index.css';
import PreGroup from './pages/pre_group';
import ChgGroup from './pages/chg_group';
import UpdSeat from './pages/upd_seat';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/invite" element={<Invite />} >
        <Route path=":label" element={<Invite />}></Route>
      </Route>
      <Route path="/prewatch" element={<RsvpList />} />
      <Route path="/pregroup" element={<PreGroup />} />
      <Route path="/groupChange" element={<ChgGroup />} />
      <Route path="/seatUpdate" element={<UpdSeat />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
